import React, { useState } from "react";
import { DialogActions, DialogContent, DialogTitle } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { CustomDialog } from "../../../components/StyledComponents";
import {
    ControlpanelPrimaryButton,
    ControlpanelSecondaryButton,
    GrayIconButton,
} from "../../../components/StyledButton";

import LeaveApi from "../../../axios/LeaveAndHoliday/LeaveApi"; // ✅ nhớ import
import { deleteAllRecipients } from "../../../axios/Setting/SettingUrlApi";

const DeleteAllRecipientsDialog = ({ open, onClose, data, onRefresh }) => {
    const { t } = useTranslation();
    const { deleteLeaveType } = LeaveApi(); // ✅ lấy hàm từ API wrapper
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        const payload = {
            langId: localStorage.getItem("i18nextLngId"),
        };

        try {
            const response = await deleteAllRecipients(payload);

            // ✅ Kiểm tra status 200 thay vì message
            if (response?.status === 200 || response?.status === 204) {
                toast.success(t("common.delete-recipients-successfully"));
                onRefresh?.();
                onClose?.();
            } else {
                toast.error(response?.data?.message || t("common.error"));
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || t("common.network-or-server-error"));
            console.error("Delete leave type error:", err);
        } finally {
            setLoading(false);
        }
        onClose?.();
    };


    return (
        <CustomDialog maxWidth="sm" open={open} onClose={() => onClose?.()} keepMounted>
            <DialogTitle>
                <div className="flex justify-between">
                    <div className="flex items-center gap-4">
                        <p className="text-xl font-semibold text-[#1A1D1F]">
                            {t("common.delete-all-notifications-email")}
                        </p>
                    </div>
                    <GrayIconButton onClick={() => onClose?.()}>
                        <CloseIcon />
                    </GrayIconButton>
                </div>
            </DialogTitle>

            <DialogContent className="!py-0">
                <div className="py-5">
                    <p className="pb-3">{t("common.are-you-sure-all-email")}</p>
                </div>
            </DialogContent>

            <DialogActions>
                <div className="flex gap-2 px-4 py-4">
                    <ControlpanelSecondaryButton onClick={() => onClose?.()} disabled={loading}>
                        <CloseIcon />
                        <p>{t("button.cancel")}</p>
                    </ControlpanelSecondaryButton>

                    <ControlpanelPrimaryButton onClick={handleSubmit} disabled={loading}>
                        <CheckIcon />
                        <p>{t("button.ok")}</p>
                    </ControlpanelPrimaryButton>
                </div>
            </DialogActions>
        </CustomDialog>
    );
};

export default DeleteAllRecipientsDialog;
